// extracted by mini-css-extract-plugin
export default {"modalContainer":"yC","fadeRight":"zC","fadeUp":"AC","topShelf":"BC","newFlavorBadge":"CC","transparentText":"EC","cancelButton":"FC","invisibleLink":"GC","closeIcon":"HC","linkContainer":"IC","hed":"JC","image":"KC"};
    if(module.hot) {
      // 1743628923635
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  